import ComicCard from '@/components/base/ComicCard';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
              热门推荐
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
              本周热门韩漫
              <br />
              不容错过的精彩
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            精选全网最受欢迎的韩国漫画，涵盖恋爱、动作、奇幻等多种类型，每一部都是读者口碑推荐之作。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredComics.map((comic, index) => (
            <ComicCard
              key={comic.id}
              {...comic}
              variant={index === 0 ? 'featured' : 'default'}
            />
          ))}
        </div>
      </div>
    </section>
  );
}